var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderArrowPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.8,
    height: 15.629,
    viewBox: "0 0 14.8 15.629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(-1630.6 -3568.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68750",
    "data-name": "Path 68750",
    d: "M24.4,24.8,18,18.4,24.4,12",
    transform: "translate(1613.6 3557.6)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68751",
    "data-name": "Path 68751",
    d: "M24.8,18H12",
    transform: "translate(1619.6 3558)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrowPrev);
export default __webpack_public_path__ + "static/media/slider_arrow_prev.076caebd7efae32d7b7c787d936d6177.svg";
export { ForwardRef as ReactComponent };